import { availableFiltersList } from "src/organisms/AlgoliaProductList/availableFilters";
import {
  BRAND_FACET,
  CATEGORIES_FACET,
  COLOUR_FACET,
  DISCOUNT_FACET,
  PATTERN_FACET,
  SIZE_FACET,
  CONSCIOUS_FACET,
  STYLE_FACET,
  PRICE_FACET,
} from "./algolia";
import {
  RangeMax,
  RangeMin,
} from "instantsearch.js/es/connectors/range/connectRange";

export const queryStringKeyMap: Record<string, string> = {
  [CATEGORIES_FACET]: "cat_slug",
  [BRAND_FACET]: "brand_slug",
  [COLOUR_FACET]: "colors",
  [PATTERN_FACET]: "patterns",
  [SIZE_FACET]: "sizes",
  [DISCOUNT_FACET]: "discount",
  [CONSCIOUS_FACET]: "goodOnYouScore",
  [STYLE_FACET]: "styles",
} as const;

export const queryStringValuePosMap: Record<string, number> = {
  [CATEGORIES_FACET]: -1,
  [BRAND_FACET]: 2,
  [COLOUR_FACET]: 0,
  [PATTERN_FACET]: 0,
  [SIZE_FACET]: 0,
  [DISCOUNT_FACET]: 0,
  [CONSCIOUS_FACET]: 0,
  [STYLE_FACET]: 0,
} as const;

export function handleSearchParams({
  facet,
  value,
  isSingle,
}: {
  facet: string;
  value: string;
  isSingle?: boolean;
}): void {
  const url = new URL(location.toString());
  const paramValue = value.split("||").at(queryStringValuePosMap[facet]) || "";
  const selected = url.searchParams.has(
    queryStringKeyMap[facet] || facet,
    paramValue
  );

  if (selected) {
    url.searchParams.delete(queryStringKeyMap[facet] || facet, paramValue);
  }

  if (!selected && !isSingle) {
    url.searchParams.append(queryStringKeyMap[facet] || facet, paramValue);
  }

  if (!selected && isSingle) {
    url.searchParams.set(queryStringKeyMap[facet] || facet, paramValue);
  }

  history.pushState(null, "", url);
}

export function handleSearchParamsPrice({
  min,
  max,
}: {
  min?: RangeMin;
  max?: RangeMax;
}): void {
  const url = new URL(location.toString());

  if (min) {
    url.searchParams.set("min_price", `${min}`);
  }

  if (max) {
    url.searchParams.set("max_price", `${max}`);
  }

  history.pushState(null, "", url);
}

export function removeAllFilters(removeCategories?: boolean): void {
  const url = new URL(location.toString());

  availableFiltersList
    .filter(({ facet }) => facet !== PRICE_FACET && facet !== CATEGORIES_FACET)
    .forEach(({ facet }) => {
      url.searchParams.delete(queryStringKeyMap[facet]);
    });

  url.searchParams.delete("min_price");
  url.searchParams.delete("max_price");

  if (removeCategories) {
    url.searchParams.delete("cat_slug");
  }

  history.pushState(null, "", url);
}

export function removePriceFilters(): void {
  const url = new URL(location.toString());

  url.searchParams.delete("min_price");
  url.searchParams.delete("max_price");

  history.pushState(null, "", url);
}

export function removeAllFiltersByKey(facet: string, value?: string): void {
  const url = new URL(location.toString());

  url.searchParams.delete(queryStringKeyMap[facet] || facet, value);

  history.pushState(null, "", url);
}
